
import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import notifications from "@/lib/notifications";
import { AgentResource, AgentCommodityResource } from "../../../models/api/system/agents";
import { getModule } from "vuex-module-decorators";
import SystemModule from "@/store/modules/system";
import permissions from "@/security/permissions";

import { AgentFacilityResourceSelect } from "../../../models/ui/manageAgent";

const systemModule = getModule(SystemModule);

@Component
export default class ManageCommodities extends Vue {
  @Prop()
  agent: AgentResource;

  @Prop()
  public agentCommodities: Array<AgentCommodityResource>;

  loading: boolean = false;
  loadingPage: boolean = false;
  agentCommodityFilter: string = "";

  agentCommodity: AgentCommodityResource = {
    agentId: null,
    commodityCode: null,
    agentCommodityCode: null,
    agentCommodityDescription: null,
    isActive: true,
    countAsUnit: false
  };

  isCommodityModalVisible: boolean = false;
  isDeleteCommodityModalVisible: boolean = false;

  async addAgentCommodity() {
    this.agentCommodity = {
      agentId: this.agent.id,
      commodityCode: null,
      agentCommodityCode: null,
      agentCommodityDescription: null,
      isActive: true,
      countAsUnit: false
    };
    this.isCommodityModalVisible = true;
  }

  async editAgentCommodity(commodityCode: string) {
    let clone = this.agentCommodities.find(x => x.commodityCode === commodityCode);
    clone = { ...clone };

    this.agentCommodity = clone;
    this.isCommodityModalVisible = true;
  }

  async saveAgentCommodity() {
    try {
      this.agentCommodity.agentId = this.agent.id;
      if (this.agentCommodity.commodityCode === null) {
        await systemModule.postAgentCommodity(this.agentCommodity);
      } else {
        await systemModule.putAgentCommodity(this.agentCommodity);
      }
      notifications.success("Success", `Commodity saved.`);
    } catch (error) {
      notifications.error('Save Failed','Unable to save commodity.', error);
    }

    this.$emit("updated");
  }

  filterCommodities(row, filter) {
    if (filter.length === 0) return true;
    if (row.commodityCode.toLowerCase().includes(filter.toLowerCase())) return true;
    if (row.agentCommodityCode.toLowerCase().includes(filter.toLowerCase())) return true;
    if (row.agentCommodityDescription.toLowerCase().includes(filter.toLowerCase())) return true;
    return false;
  }
}
